import CannedFishProduct from 'models/CannedFishProduct'

export const fishTypeOptions = [
  {
    value: '',
    label: 'Fish Type',
    isDisabled: true,
  },
  {
    value: 'Chunk, Light Tuna - 5 oz.',
    label: 'Chunk, Light Tuna - 5 oz.',
    subCategory: '001',
  },
  {
    value: 'Mackerel - 15 oz.',
    label: 'Mackerel - 15 oz.',
    subCategory: '004',
  },
  {
    value: 'Pink Salmon - 5 oz.',
    label: 'Pink Salmon - 5 oz.',
    subCategory: '002',
  },
  {
    value: 'Pink Salmon - 6 oz.',
    label: 'Pink Salmon - 6 oz.',
    subCategory: '002',
  },
  {
    value: 'Pink Salmon - 14.75 oz.',
    label: 'Pink Salmon - 14.75 oz.',
    subCategory: '002',
  },
  {
    value: 'Sardines - 15 oz.',
    label: 'Sardines - 15 oz.',
    subCategory: '003',
  },
]

export const packedInOptionsDefault = [
  {
    value: '',
    label: 'Packed in',
    isDisabled: true,
  },
]

export const tunaPackedInOptions = [
  {
    value: '',
    label: 'Packed in',
    isDisabled: true,
  },
  { value: 'Water', label: 'Water' },
]

export const mackerelPackedInOptions = [
  {
    value: '',
    label: 'Packed in',
    isDisabled: true,
  },
  { value: 'Water', label: 'Water' },
  { value: 'Tomato Sauce', label: 'Tomato Sauce' },
]

export const salmonPackedInOptions = [
  {
    value: '',
    label: 'Packed in',
    isDisabled: true,
  },
  { value: 'Water', label: 'Water' },
]

export const sardinesPackedInOptions = [
  {
    value: '',
    label: 'Packed in',
    isDisabled: true,
  },
  { value: 'Water', label: 'Water' },
  {
    value: 'Mustard',
    label: 'Mustard',
  },
  { value: 'Tomato Sauce', label: 'Tomato Sauce' },
]

export const packagingInitialState = {
  category: CannedFishProduct.category,
  subCategory: CannedFishProduct.subCategory,
  FishType: {
    value: fishTypeOptions[0].value,
    label: fishTypeOptions[0].label,
  },
  PackedIn: {
    value: packedInOptionsDefault[0].value,
    label: packedInOptionsDefault[0].label,
  },
}
